import {
  AuthPostRegAcknowledgePartialReg,
  LazyAuthRegistration,
  AuthLogin,
  LazyAuthPostReg01VerifyName,
  AuthPostReg02CardWelcomeMessage,
  LazyUserPasswordResetOptions,
  LazyUserPasswordResetEnterOtp,
  LazyAuthPostReg04PartialCompletion,
  LazyAuthPostRegCompleteRegistration,
  UserProfileManagementMobileNumbersNumberChangeLogoutAlert,
  UserProfileManagementMobileNumbersConfirmNumberDelete,
  UserProfileManagementMobileNumbersVerifyOtp,
  LazyAuthPostReg05FullCompletion,
  LazyMarketingNotificationsNewNotificationModal,
  LazyUserProfileManagementForgotLoginChangePassword,
  LazyUserProfileManagementInfoChangeSuccess,
  LazyUserProfileManagementForgotLogin,
  LazyUserProfileManagementForgotLoginChangeNumber,
} from '#components';
import type { TModalConfig } from '~/interfaces/content/modals';
import { useNotifications } from '~/composables/useStates/useNotifications';

export const getAuthModals = (): TModalConfig => {
  const auth = useAuthStore();
  const { newNotifications, timeSinceNotification } = useNotifications();
  const notification = newNotifications.value?.[0];
  const { $t } = useNuxtApp();
  return {
    'acknowledge-partial-reg': {
      modalProps: { title: 'complete-registration', showClose: false },
      component: () => AuthPostRegAcknowledgePartialReg,
    },
    confirmMobileNumberDelete: {
      modalProps: {
        title: 'confirm-mobile-number-delete-alert',
        showClose: false,
      },
      component: () => UserProfileManagementMobileNumbersConfirmNumberDelete,
    },
    'complete-registration': {
      modalProps: { title: 'complete-registration' },
      component: () => LazyAuthPostRegCompleteRegistration,
    },
    login: {
      modalProps: { title: 'login' },
      component: () => AuthLogin,
    },
    newNotification: {
      modalProps: {
        title:
          notification?.notificationStyle === 'Coupon'
            ? `<div class="flex items-center justify-center place-self-center gap-2">
                <span class="text-sm">
                  ${timeSinceNotification(notification.notificationDate)}
                </span>
                <span
                  class="inline-block h-2 w-2 rounded-full bg-primary-blue-gradient"
                  aria-label="unread"
                />
              </div>`
            : notification?.messageHeader || $t('new-notification'),
        forceUntranslatedTitle: true,
        size: '320px !important',
      },
      component: () => LazyMarketingNotificationsNewNotificationModal,
    },
    numberChangeLogoutAlert: {
      modalProps: {
        title: 'primary-number-change-logout-alert',
      },
      component: () =>
        UserProfileManagementMobileNumbersNumberChangeLogoutAlert,
    },
    passwordResetEnterOtp: {
      modalProps: { title: 'password-reset-title' },
      component: () => LazyUserPasswordResetEnterOtp,
    },
    passwordResetStepOne: {
      modalProps: { title: 'password-reset-title' },
      component: () => LazyUserPasswordResetOptions,
    },
    passwordResetStepSuccess: {
      modalProps: {
        title: auth.loggedIn ? 'update-password' : 'forgot-password-title',
        showClose: false,
      },
      contentProps: { successType: 'password' },
      component: () => LazyUserProfileManagementInfoChangeSuccess,
    },
    register: {
      modalProps: { title: 'jpc-register' },
      component: () => LazyAuthRegistration,
    },
    registrationFullCompletion: {
      modalProps: { title: 'welcome-to-jpc' },
      component: () => LazyAuthPostReg05FullCompletion,
    },
    registrationPartialCompletion: {
      modalProps: { title: 'welcome-to-jpc', showClose: false },
      component: () => LazyAuthPostReg04PartialCompletion,
    },
    registrationVerifyName: {
      modalProps: { title: 'welcome-to-jpc', showClose: false },
      component: () => LazyAuthPostReg01VerifyName,
    },
    registrationWelcomeOffer: {
      modalProps: { title: 'welcome-to-jpc' },
      component: () => AuthPostReg02CardWelcomeMessage,
    },
    'sign-up': {
      modalProps: { title: 'jpc-register' },
      component: () => LazyAuthRegistration,
    },
    sumSubPasswordResetLoggedOutChangeNumber: {
      modalProps: {
        title: 'change-number',
        closeOnBackdrop: false,
        closeOnEsc: false,
        showClose: false,
      },
      component: () => LazyUserProfileManagementForgotLoginChangeNumber,
    },
    sumSubPasswordResetLoggedOutChangeNumberSuccess: {
      modalProps: {
        title: 'change-primary-success',
        closeOnBackdrop: false,
        closeOnEsc: false,
        showClose: false,
      },
      contentProps: { successType: 'number' },
      component: () => LazyUserProfileManagementInfoChangeSuccess,
    },
    sumSubPasswordResetLoggedOutChangePassword: {
      modalProps: { title: 'change-password' },
      contentProps: { successType: 'password' },
      component: () => LazyUserProfileManagementForgotLoginChangePassword,
    },
    sumSubPasswordResetLoggedOutChangePasswordSuccess: {
      modalProps: {
        title: 'change-password-success',
        closeOnBackdrop: false,
        closeOnEsc: false,
        showClose: false,
      },
      contentProps: { successType: 'password' },
      component: () => LazyUserProfileManagementInfoChangeSuccess,
    },
    sumSubPasswordResetLoggedOutLivenessCheck: {
      modalProps: {
        title: 'forgot-login-info',
      },
      component: () => LazyUserProfileManagementForgotLogin,
    },
    verifyNumberOtp: {
      modalProps: { title: 'secondary-number-verify-otp', showClose: false },
      component: () => UserProfileManagementMobileNumbersVerifyOtp,
    },
  } as const satisfies TModalConfig;
};
